import ShipmentHistoryName from "./ShipmentHistoryName";
import ShipmentHistoryLink from "./ShipmentHistoryLink";

import ShipmentName from "../../../../timber/components/shipment/ShipmentDetail/ShipmentName";
import ShipmentLink from "../../../../timber/components/shipment/ShipmentDetail/ShipmentLink";

import TimberStorageName from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageName";
import TimberStorageLink from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageLink";

import CuttingName from "../../../../timber/components/cutting/CuttingDetail/CuttingName";
import CuttingLink from "../../../../timber/components/cutting/CuttingDetail/CuttingLink";

import BuyerName from "../../../../timber/components/buyer/BuyerDetail/BuyerName";
import BuyerLink from "../../../../timber/components/buyer/BuyerDetail/BuyerLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ShipmentHistoryDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="ShipmentHistory-detail-title"
                    >
                        { label || t`Shipment History` }: <ShipmentHistoryName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="ShipmentHistory-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="ShipmentHistory-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentId-label" sx={{ textAlign: "left" }}><Trans>Shipment</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentId-value" sx={{ textAlign: "left" }}>{ data.shipmentId ? (<ShipmentLink id={ data.shipmentId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="key-label" sx={{ textAlign: "left" }}><Trans>Key</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="key-value" sx={{ textAlign: "left" }}>{ data.key || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="action-label" sx={{ textAlign: "left" }}><Trans>Action</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="action-value" sx={{ textAlign: "left" }}>{ data.action || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="contextHistory-label" sx={{ textAlign: "left" }}><Trans>Context History</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="contextHistory-value" sx={{ textAlign: "left" }}>{ data.contextHistory || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="updatedAt-label" sx={{ textAlign: "left" }}><Trans>Updated At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="updatedAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.updatedAt) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="storageId-label" sx={{ textAlign: "left" }}><Trans>Timber Storage</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="storageId-value" sx={{ textAlign: "left" }}>{ data.storageId ? (<TimberStorageLink id={ data.storageId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentAt-label" sx={{ textAlign: "left" }}><Trans>Shipment At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.shipmentAt) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="cuttingId-label" sx={{ textAlign: "left" }}><Trans>Cutting</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="cuttingId-value" sx={{ textAlign: "left" }}>{ data.cuttingId ? (<CuttingLink id={ data.cuttingId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="buyerId-label" sx={{ textAlign: "left" }}><Trans>Buyer</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="buyerId-value" sx={{ textAlign: "left" }}>{ data.buyerId ? (<BuyerLink id={ data.buyerId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="state-label" sx={{ textAlign: "left" }}><Trans>State</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="state-value" sx={{ textAlign: "left" }}>{ toStringShipmentState(data.state) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="localCreatedAt-label" sx={{ textAlign: "left" }}><Trans>Local Created At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="localCreatedAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.localCreatedAt) || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default ShipmentHistoryDetail;
